<template>
  <div class="wrapper">
    <div class="top-nav">
      <div>
        <nav-common :nav="nav"></nav-common>
      </div>
    </div>
    <div class="detail">
      <item-detail :detail="detail"></item-detail>
    </div>
  </div>
</template>
<style scoped>
.top-nav {
  width: 100%;
  display: flex;
}
.detail {
  margin-top: 30px;
  width: 100%;
  border-width: 20px 1px 1px 1px;
  border-style: solid;
  border-color:#E6ECF2;
  padding:40px 30px;
  box-sizing: border-box;
  border-radius: 10px;

}
</style>

<script>
import navCommon from "@/components/views/common/nav.vue";
import itemDetail from "@/components/views/common/itemDetail.vue";
import { userApi } from "@/api/user.js";
export default {
  data() {
    return {
      nav: {
        firsttitle: "新闻",
        firstrouteName: "NewsList",
        secondtitle: "",
        secondrouteName: "",
        thirdtitle: "",
        thirdrouteName: ""
      },
      detail:{}
    };
  },
  methods: {
    getDetail() {
      userApi.getnewDeatil({id:this.$route.query.id}).then(res => {
        this.detail = res.data;
      });
    }
  },
  components: {
    navCommon,
    itemDetail
  },
  mounted() {
    if (this.$route.query.newsFlag == "2") {
      this.nav.secondtitle = "部内要闻";
    } else if (this.$route.query.newsFlag == "3") {
      this.nav.secondtitle = "中心动态";
    } else if (this.$route.query.newsFlag == "4") {
      this.nav.secondtitle = "活动新闻";
    } else {
      this.nav.secondtitle = "推荐新闻";
    }
    
  this.getDetail()
  }
};
</script>




// WEBPACK FOOTER //
// src/components/views/News/detail.vue